const CONST = {

    'k': 'c0ff70cc197a07dff1fb709688170426',
    'i': 'f8b4e45085a1045902c3c69c80e67a7c',

    'domain': (host = 'bimic', domain = 'ir') => `https://panel.${host}.${domain}/newapi/`,  //HOST
    'DB': '@Bimic',
    'RELEASE': true,
    'APP_NAME': 'بیمیک',
    'LOG': true,
    'SUB_DOMAIN': '@agency',
    'DAYS': ['saturday', 'sunday', 'monday', 'tuesday', 'wednesday', 'thursday', 'friday'],
    'DAYS_FA': ['شنبه', 'یکشنبه', 'دوشنبه', 'سه شنبه', 'چهار شنبه', 'پنجشنبه', 'جمعه'],
    'DEFAULT_INSURANCE': 1,
    'INSURANCE_TYPE': {
        'INSURANCE_TYPE_SALES': {id: 1},
        'INSURANCE_TYPE_BODY': {id: 2},
        'INSURANCE_TYPE_LIFE': {id: 3},
        'INSURANCE_TYPE_FIRE': {id: 4},
        'INSURANCE_TYPE_TRAVEL': {id: 5},
        'INSURANCE_TYPE_ELECTRONIC_DEVICE': {id: 6},
        'INSURANCE_TYPE_SOLO_EVENTS_PACKAGE': {id: 7},
        'INSURANCE_TYPE_FIRE_PACKAGE': {id: 11},
        'INSURANCE_TYPE_LIFE_PACKAGE': {id: 12},
        'INSURANCE_TYPE_PUBLIC': {id: 100},
        'INSURANCE_TYPE_RADIOLOGIST': {id: 9},
        'INSURANCE_TYPE_ARMAN_FAMILY_PACKAGE': {id: 101},
        'INSURANCE_TYPE_ELEVATOR': {id: 8},
        'INSURANCE_TYPE_HEALTH': {id: 13},
    },

    'INSURANCE_TYPE_NAME': {
        'sales': {id: 1},
        'body': {id: 2},
        'life': {id: 3},
        'fire': {id: 4},
        'travel': {id: 5},
        'electronicDevice': {id: 6},
        'soloEventsPackage': {id: 7},
        'firePackage': {id: 11},
        'lifePackage': {id: 12},
        'public': {id: 100},
        'RADIOLOGIST': {id: 9},
        "armanFamilyPackage": {id: 101},
        "elevator": {id: 8},
        "health": {id: 13},
    },
    'INSURANCE_FA': {
        0: '',
        1: 'شخص ثالث',
        2: 'بدنه',
        3: 'عمر',
        4: 'آتش سوزی و زلزله',
        5: 'مسافرتی',
        6: 'لوازم الکترونیکی',
        7: 'حوادث انفرادی',
        11: 'طرح های آتش سوزی و زلزله',
        12: 'عمر و سرمایه گذاری',
        100: 'خرید سایر بیمه نامه ها',
        9: 'مسئولیت پزشکان ',
        101: 'طرح های خانواده آرمانی',
        8: 'آسانسور نفربر',
        13: 'درمان',
    },

    'INSURANCE_EN': {
        0: '',
        1: 'third-party-insurance',
        2: 'body-insurance',
        3: 'life-insurance',
        4: 'fire-insurance',
        5: 'travel-insurance',
        6: 'electronic-device-insurance',
        7: 'personal-accident-insurance',
        11: 'fire-package-insurance',
        12: 'life-package-insurance',
        100: 'other-insurance',
        8: 'elevator',
        13: 'health',
        // 9: 'مسئولیت پزشکان ',
        // 101: 'طرح های خانواده آرمانی'
    },

    'INSURANCE_TYPES': [
        {value: 1, name: 'شخص ثالث'},
        {value: 2, name: 'بدنه'},
        {value: 3, name: 'عمر'},
        {value: 4, name: 'آتش سوزی و زلزله'},
        {value: 5, name: 'مسافرتی'},
        {value: 6, name: 'لوازم الکترونیکی'},
        {value: 7, name: 'حوادث انفرادی'},
        {value: 11, name: 'طرح های آتش سوزی و زلزله'},
        {value: 12, name: 'عمر و سرمایه گذاری'},
        {value: 100, name: 'خرید سایر بیمه نامه ها'},
        {value: 9, name: 'مسئولیت پزشکان'},
        {value: 101, name: 'طرح های خانواده آرمانی'},
        {value: 8, name: 'آسانسور نفربر'},
        {value: 13, name: 'درمان'},
    ],
    'INSURANCE_TYPES_POST': [
        {value: 64, name: 'شخص ثالث'},
        {value: 73, name: 'بدنه'},
        {value: 76, name: 'عمر'},
        {value: 67, name: 'آتش سوزی و زلزله'},
        {value: 79, name: 'مسافرتی'},
        {value: 110, name: 'لوازم الکترونیکی'},
        {value: 131, name: 'حوادث انفرادی'},
        {value: 67, name: 'طرح های آتش سوزی و زلزله'},
        {value: 76, name: 'عمر و سرمایه گذاری'},
        {value: 100, name: 'خرید سایر بیمه نامه ها'},
        {value: 9, name: 'مسئولیت پزشکان'},
        {value: 101, name: 'طرح های خانواده آرمانی'},
        {value: 8, name: 'آسانسور نفربر'},
        {value: 13, name: 'درمان'},
    ],
    'IMAGE_POSITION': [
        {value: 1, PositionX: 0, PositionY: 0, name: 'ایران'},
        {value: 2, PositionX: 153, PositionY: 0, name: 'بیمیک'},
        {value: 3, PositionX: 116, PositionY: 1, name: 'آسیا'},
        {value: 4, PositionX: 77, PositionY: 0, name: 'البرز'},
        {value: 5, PositionX: 39, PositionY: 1, name: 'دانا'},
        {value: 6, PositionX: 1, PositionY: 193, name: 'پارسیان'},
        {value: 7, PositionX: 347, PositionY: 194, name: 'پاسارگاد'},
        {value: 8, PositionX: 307, PositionY: 193, name: 'رازی'},
        {value: 9, PositionX: 77, PositionY: 194, name: 'ملت'},
        {value: 10, PositionX: 38, PositionY: 194, name: 'ما'},
        {value: 11, PositionX: 193, PositionY: 153, name: 'کارآفرین'},
        {value: 12, PositionX: 154, PositionY: 155, name: 'دی'},
        {value: 13, PositionX: 307, PositionY: 154, name: 'سامان'},
        {value: 14, PositionX: 76, PositionY: 154, name: 'سینا'},
        {value: 15, PositionX: 38, PositionY: 155, name: 'نوین'},
        {value: 16, PositionX: 0, PositionY: 116, name: 'معلم'},
        {value: 17, PositionX: 153, PositionY: 115, name: 'میهن'},
        {value: 18, PositionX: 115, PositionY: 115, name: 'کوثر'},
        {value: 19, PositionX: 77, PositionY: 115, name: 'آرمان'},
        {value: 20, PositionX: 38, PositionY: 115, name: 'تعاون'},
        {value: 21, PositionX: 1, PositionY: 308, name: 'تجارت نو'},
        {value: 22, PositionX: 155, PositionY: 308, name: 'سرمد'},
        {value: 23, PositionX: 115, PositionY: 78, name: 'حکمت صبا'},
        // {value: 24, PositionX: 153, PositionY: 0, name: 'بیمیک'},
        {value: 25, PositionX: 37, PositionY: 77, name: 'مرکزی'},
        {value: 26, PositionX: 192, PositionY: 39, name: 'خاورمیانه'},
        {value: 27, PositionX: 154, PositionY: 38, name: 'باران'},
    ],
    'COMPANY': [
        {index: 1,value: 'ایران'},
        {index: 2, value: 'بیمیک'},
        {index: 3, value: 'آسیا'},
        {index: 4,value: 'البرز'},
        {index: 5,value: 'دانا'},
        {index: 6, value: 'پارسیان'},
        {index: 7, value: 'پاسارگاد'},
        {index: 8, value: 'رازی'},
        {index: 9, value: 'ملت'},
        {index: 10, value: 'ما'},
        {index: 11, value: 'کارآفرین'},
        {index: 12, value: 'دی'},
        {index: 13, value: 'سامان'},
        {index: 14, value: 'سینا'},
        {index: 15, value: 'نوین'},
        {index: 16 ,value: 'معلم'},
        {index: 17, value: 'میهن'},
        {index: 18, value: 'کوثر'},
        {index: 19, value: 'آرمان'},
        {index: 20, value: 'تعاون'},
        {index: 21 , value: 'تجارت نو'},
        {index: 22, value: 'سرمد'},
        {index: 23, value: 'حکمت صبا'},
        // {index: 24 value: 'بیمیک'},
        {index: 25, value: 'مرکزی'},
        {index: 26, value: 'خاورمیانه'},
        {index: 27, value: 'باران'},
    ],
    'BODY_SALES': [
        {index: 0,value: ' 0 درصد'},
        {index: 5, value: ' 5 درصد'},
        {index: 10, value: ' 10 درصد'},
        {index: 15,value: ' 15 درصد'},
        {index: 20,value: ' 20 درصد'},
        {index: 25,value: ' 25 درصد'},
        {index: 30,value: ' 30 درصد'},
        {index: 35,value: ' 35 درصد'},
        {index: 40,value: ' 40 درصد'},
        {index: 45,value: ' 45 درصد'},
        {index: 50,value: ' 50 درصد'},
        {index: 55,value: ' 55 درصد'},
        {index: 60,value: ' 60 درصد'},
        {index: 65,value: ' 65 درصد'},
        {index: 70,value: ' 70 درصد'},
    ],

    'INTRO': [
        {
            message: 'اگه دنبال خرید بیمه نامه هستی در این نوار با کلیک می تونی نوع بیمه نامه مورد نظرت رو انتخاب کنی',
            element: '.scroll'
        },
        {
            message: 'در این قسمت توضیحی اجمالی درباره نوع بیمه نامه انتخاب شده نمایش داده میشه اگه دنبال توضیحات مفصل تر هستی روی دکمه بیشتر کلیک کن و به قسمت های راهنمای خرید، سوالات متداول و ... سر بزن',
            element: '.OrderInfo'
        },
        {
            message: 'اینجا شرکت هایی که این نوع بیمه نامه رو در سامانه بیمیک ارائه میدن میبینی',
            element: '.insurance-providers'
        },
        {
            message: 'در این قسمت حداقل اطلاعاتی که برای محاسبه حق بیمه نیاز هست باید وارد کنی و دکمه محاسبه کن رو بزنی تا حق بیمه رو در صفحه بعد ببینی',
            element: '.InsuranceSalesTab '
        },
        {message: 'نوع بیمه نامه و تاریخ انقضاشو مشخص کن و باقیشو به ما بسپار', element: '.Form'},
        {message: 'هرجا که سوالی داشتی میتونی از این قسمت با ما در ارتباط باشی ', element: '.raychat-fake'},
        {message: ' با این شماره باهامون تماس بگیری، خوشحال میشیم ', element: '.FooterColumn div'},
    ],

    'INTROAGENT': [
        {
            message: ' \tبا کلیک روی این دکمه می تونی به وب سایت مخصوص نماینده ها و کارگزاران مراجعه کنی\n' + '\tاونجا کلی خبر درباره خدمات سامانه بیمیک برای رونق کسب وکار شبکه فروش هست.\n' + '\tتو هم میتونی با ثبت نام تو سامانه در کوتاهترین زمان وب سایت اختصاصی خودت رو داشته باشی.\n',
            element: '.Header_bottom_section .Btns '
        },
        {message: 'هرجا که سوالی داشتی میتونی از این قسمت با ما در ارتباط باشی ', element: '.raychat-fake'},
        {message: ' با این شماره باهامون تماس بگیری، خوشحال میشیم ', element: '.FooterColumn div'},
    ],
    'LIKE': [
        {'like': 2, "unlike": 3},
        {'like': 5, "unlike": 10}
    ],

    "deviceType": {
        0: "",
        1: "سواری",
        2: "موتورسیکلت",
        3: "بارکش",
        4: "اتوکار",
    },
    "new_insurace_duration": {
        2: "دو ماهه ",
        3: "سه ماهه",
        4: "چهار ماهه",
        6: "شش ماهه",
        12: "یک ساله",
    },
    "GOOGLE_ANALITYC": {
        3062: "G-PFM29CCZFF",
        73: "UA-140821291-1",
        446: "UA-166252401-1",
        3090: "UA-192838392-1",
        3325:"G-Q07C4BZ22X",
        3350:"UA-215409261-1",
        3329:"UA-231294612-2"
    },
    "GOOGLE_TAG_MANAGER": {
        3329:"GTM-MZPBNMF",
    },
    REGIONS: [
        {
            "city_id": 498,
            "city_title": "منطقه 1"
        },
        {
            "city_id": 765,
            "city_title": "منطقه 2"
        },
        {
            "city_id": 766,
            "city_title": "منطقه 3"
        },
        {
            "city_id": 767,
            "city_title": "منطقه 4"
        },
        {
            "city_id": 768,
            "city_title": "منطقه 5"
        },
        {
            "city_id": 769,
            "city_title": "منطقه 6"
        },
        {
            "city_id": 770,
            "city_title": "منطقه 7"
        },
        {
            "city_id": 771,
            "city_title": "منطقه 8"
        },
        {
            "city_id": 772,
            "city_title": "منطقه 9"
        },
        {
            "city_id": 773,
            "city_title": "منطقه 10"
        },
        {
            "city_id": 774,
            "city_title": "منطقه 11"
        },
        {
            "city_id": 775,
            "city_title": "منطقه 12"
        },
        {
            "city_id": 776,
            "city_title": "منطقه 13"
        },
        {
            "city_id": 777,
            "city_title": "منطقه 14"
        },
        {
            "city_id": 778,
            "city_title": "منطقه 15"
        },
        {
            "city_id": 779,
            "city_title": "منطقه 16"
        },
        {
            "city_id": 780,
            "city_title": "منطقه 17"
        },
        {
            "city_id": 781,
            "city_title": "منطقه 18"
        },
        {
            "city_id": 782,
            "city_title": "منطقه 19"
        },
        {
            "city_id": 783,
            "city_title": "منطقه 20"
        },
        {
            "city_id": 784,
            "city_title": "منطقه 21"
        },
        {
            "city_id": 785,
            "city_title": "منطقه 22"
        },
    ],
    "ELEVATOR":
        {
            "type":
                {
                    1: "نفر بر"
                },
            "usage":
                {
                    1: "مسکونی",
                    2: "تجاری",
                    3: "اداری",
                },
            "capacity":
                {
                    2: "2",
                    3: "3",
                    4: "4",
                    5: "5",
                    6: "6",
                    7: "7",
                    8: "8",
                    9: "9",
                    10: "10",
                    11: "11",
                    12: "12",
                    13: "13",
                    14: "14",
                    15: "15",
                    16: "16",
                    17: "17",
                    18: "18",
                    19: "19",
                    20: "20",
                },
            "floor":
                {
                    1: "تا 15 طبقه",
                    2: "بیشتر از 15 طبقه",
                },
            "medical_price":
                {
                    1: "10,000,000",
                    2: "30,000,000 ",
                    3: "40,000,000 ",
                },
        },
    "POLICY": {
        "privacy_policy": "<p><strong>شرایط خصوصی بیمه آسانسور</strong></p>\n" +
            "<p><strong><strong>&nbsp;</strong></strong></p>\n" +
            "<p><strong><strong>خطرات تحت پوشش </strong></strong></p>\n" +
            "<p>&nbsp;سقوط، برق گرفتگی، حبس شدن و سایر حوادثی که ناشی از مسئولیت بیمه گذار بوده و در این بیمه نامه استثناء نباشد.</p>\n" +
            "<p><strong><strong>استثنائات</strong></strong></p>\n" +
            "<p>-خسارت ناشی از استفاده از آسانسور غیراستاندارد</p>\n" +
            "<p>-خسارت ناشی از استفادهی بیش از ظرفیت آسانسور</p>\n" +
            "<p>-خسارت وارد به کارکنان شرکت های نصب یا نگهداری</p>\n" +
            "<p>- هرگونه خسارت ناشی از آسانسور و محل نصب آن در شرایط غیر از بهره برداری</p>\n" +
            "<p>-خسارت های غیر مستقیم وعدم النفع: کلیه&nbsp;خسارت های&nbsp;ناشی&nbsp;از عدم النفع اعم از توقف در تولید،&nbsp;اجاره،&nbsp;افت&nbsp;قیمت،&nbsp;سود&nbsp;و زیان،&nbsp;توقف&nbsp;کسب و کار،&nbsp;حقوق و دستمزد،&nbsp;ادعای&nbsp;ناشی&nbsp;از خسارات وارده به محیط&nbsp;زیست،&nbsp;محکومیت&nbsp;های&nbsp;جزایی&nbsp;قابل خرید&nbsp;و محکومیت&nbsp;های&nbsp;نقدی&nbsp;به نفع دولت و سایر&nbsp;موارد از این&nbsp;قبیل&nbsp;از شمول تعهدات این&nbsp;بیمه&nbsp;نامه خارج است.</p>\n" +
            "<p>-خسارت مالی</p>\n" +
            "<p>&nbsp;</p>\n" +
            "<p>-ارائه ی تصویر قرارداد سرویس و نگهداری آسانسور با یک شرکت معتبر، در زمان خسارت الزامی است، در غیر اینصورت بیمه گر تعهدی در پرداخت خسارت نخواهد داشت.</p>\n" +
            "<p>- تعهدات بیمه&zwnj;گر برای هر آسانسور حداکثر به میزان ظرفیت استاندارد آسانسور می&zwnj;باشد.</p>\n" +
            "<p>-در صورت حمل بیش از ظرفیت آسانسور بیمه گر تعهدی در قبال پرداخت خسارت نخواهد داشت.</p>\n" +
            "<p>-پرداخت خسارت منوط به انجام بازدیدهای دوره ای و صدور گواهی بازدید توسط اشخاص ذیصلاح میباشد.</p>\n" +
            "<p>- در صورتی که ساختمان نوساز و دارای عمر کمتر از 10 سال باشد ، ارائه قرارداد سرویس و نگهداری دوره ای در زمان صدور یا خسارت الزامی است.</p>\n" +
            "<p>- در صورتی که عمر ساختمان بیشتر از 10 سال می باشد ، ارائه قرارداد سرویس و نگهداری دوره ای در زمان صدور الزامی است.</p>",
        "public_policy": "<p><strong>&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;</strong><strong><u>شرایط عمومی بیمه نامه مسئولیت مدنی دارندگان و نصابان آسانسور در قبال استفاده کنندگان</u></strong></p>\n" +
            "<p><strong><strong>فصل اول</strong></strong><strong><strong>: </strong></strong><strong><strong>کلیات</strong></strong></p>\n" +
            "<p><strong><strong>ماده</strong></strong><strong><strong>1- </strong></strong><strong><strong>اساس بیمه نامه </strong></strong>: این بیمه نامه بر اساس قانون مصوب اردیبهشت ماه، سال 1316 و سایر قوانین و مقررات مرتبط و پیشنهاد کتبی بیمه گذار ( که جزء لاینفک این بیمه نامه می باشد) تنظیم گردیده و مورد توافق طرفین می باشد. آن قسمت از پیشنهاد بیمه گذار که مورد قبول بیمه گر نبوده و همزمان با صدور بیمه نامه یا قبل از آن کتباً به بیمه گذار اعلام گردیده است، جز تعهدات بیمه گر محسوب نمی شود.</p>\n" +
            "<p><strong><strong>ماده</strong></strong><strong><strong>2- </strong></strong><strong><strong>تعاریف و اصطلاحات</strong></strong><strong><strong>: </strong></strong>اصطلاحات زیر در این شرایط عمومی با تعریف مقابل آن به کار رفته است:</p>\n" +
            "<p><strong><strong>1.</strong></strong><strong><strong>فعالیت موضوع بیمه</strong></strong>&nbsp;: انتقال مسافر و &nbsp;بار که توسط آسانسور صورت می پذیرد.</p>\n" +
            "<p><strong><strong>2.</strong></strong><strong><strong>بیمه گر</strong></strong>: مؤسسه بیمه ای است که دارای پروانه فعالیت از بیمه مرکزی جمهوری اسلامی ایران بوده و مجاز به انجام عملیات بیمه در این رشته است.</p>\n" +
            "<p><strong><strong>3.</strong></strong><strong><strong>حق بیمه</strong></strong><strong><strong>:</strong></strong>&nbsp;وجهی که بیمه گذار در برابر اخذ پوشش و تعهد بیمه گر برای جبران خسارت ناشی از وقوع یا بروز حادثه تحت پوشش بیمه نامه می پردازد.</p>\n" +
            "<p><strong><strong>4.</strong></strong><strong><strong>بیمه گذار</strong></strong><strong><strong>:</strong></strong>&nbsp;هر شخص حقیقی یا حقوقی که قرارداد بیمه را با بیمه گر منعقد می کند و متعهد به پرداخت حق بیمه می باشد.</p>\n" +
            "<p><strong><strong>5.</strong></strong><strong><strong>زیاندیده گان</strong></strong>: استفاده کنندگان از آسانسور که در اثر وقوع حادثه موضوع بیمه دچار خسارت جانی و یا خسارت مالی گردیده اند.</p>\n" +
            "<p><strong><strong>6.</strong></strong><strong><strong>حادثه موضوع بیمه</strong></strong><strong><strong>: </strong></strong>رویدادی است که حین و به مناسبت انجام فعالیت موضوع بیمه و در مدت اعتبار بیمه نامه اتفاق افتد و منجر به خسارت جانی و یا خسارت مالی وارد به استفاده کنندگان از آسانسور گردد و بیمه گذار مسئول جبران خسارت یا پرداخت غرامت ناشی از آن شناخته شود.</p>\n" +
            "<p>تبصره: حوادثی که دارای یک منشاء یا علت اصلی واحد باشند در مجموع حکم یک حادثه تلقی می گردد.</p>\n" +
            "<ol start=\"7\">\n" +
            "<li><strong><strong>محدوده مکانی موضوع بیمه</strong></strong><strong><strong>:</strong></strong>محدوده ای است که آسانسور در آن واقع شده و از طریق درج نشانی یا تعیین حدود آن در شرایط خصوصی بیمه نامه مشخص می گردد.</li>\n" +
            "<li><strong><strong>نقص عضو</strong></strong><strong><strong>:</strong></strong>قطع، تغییر شکل و یا از دست دادن توانایی انجام کار عضوی از اعضای بدن که ناشی از حادثه موضوع بیمه بوده و وضعیت دائم و قطعی داشته باشد.</li>\n" +
            "<li><strong><strong>غرامت فوت و نقص عضو</strong></strong><strong><strong>:</strong></strong>وجهی است که بیمه گر متعهد می گردد در صورت بروز صدمات جسمی یا فوت استفاده کنندگان آسانسور ناشی از وقوع حادثه مشمول بیمه طبق شرایط این بیمه نامه &nbsp;به زیاندیده یا وارث قانونی وی بپردازد.</li>\n" +
            "<li><strong><strong>خسارت جانی</strong></strong><strong><strong>:</strong></strong>وجهی است که بیمه گر متعهد می گردد در صورت بروز حادثه مشمول بیمه بابت غرامت فوت، دیه یا ارش ناشی از جرح، نقص عضو و هزینه پزشکی به زیاندیده یا وارث قانونی وی بپردازد.</li>\n" +
            "</ol>\n" +
            "<p><strong><strong>11-</strong></strong><strong><strong>خسارت مالی</strong></strong><strong><strong>:</strong></strong>&nbsp;وجهی است که بیمه گر متعهد می گردد در صورت بروز حادثه مشمول بیمه طبق شرایط این بیمه نامه به زیاندیده یا وارث قانونی وی &nbsp;بپردازد.</p>\n" +
            "<p><strong><strong>ماده </strong></strong><strong><strong>3- </strong></strong><strong><strong>مدت بیمه نامه</strong></strong><strong><strong>: </strong></strong>شروع و انقضای مدت بیمه نامه به ترتیبی خواهد بود که در شرایط خصوصی بیمه نامه مشخص می گردد.</p>\n" +
            "<p><strong><strong>ماده </strong></strong><strong><strong>4- </strong></strong><strong><strong>موضوع بیمه نامه</strong></strong><strong><strong>:</strong></strong>&nbsp;عبارت است از بیمه مسئولیت مدنی دارندگان و نصابان آسانسور در قبال استفاده کنندگان از آسانسور / آسانسورهای مشخص شده در بیمه نامه، بدین معنا که چنانچه در نتیجه قصور و یا اهمال غیر عمدی بیمه گذار خسارتی به افراد مورد اشاره وارد آید و بیمه گذار بر اساس رای مراجع قضایی مسئول جبران خسارت شناخته گردد &nbsp;بیمه گر پس از احراز مسئولیت بیمه گذار با توجه به شرایط و مفاد بیمه نامه، حداکثر تا سقف تعهدات مندرج در بیمه نامه نسبت به جبران خسارت اقدام خواهد نمود.</p>\n" +
            "<p><strong><strong>فصل دوم</strong></strong><strong><strong>: </strong></strong><strong><strong>خسارت ها و هزینه های تحت پوشش بیمه نامه</strong></strong></p>\n" +
            "<p><strong><strong>ماده </strong></strong><strong><strong>5- </strong></strong><strong><strong>موارد زیر با صدور بیمه نامه در تعهد بیمه گر خواهد بود</strong></strong><strong><strong>:</strong></strong></p>\n" +
            "<p><strong><strong>1-5: </strong></strong><strong><strong>غرامت فوت</strong></strong><strong><strong>: </strong></strong>بر اساس رأی مراجع قضایی و حداکثر تا سقف تعهدات مندرج در شرایط خصوصی بیمه نامه یا معادل ارزان ترین نوع دیه رایج هر کدام که کمتر باشد.</p>\n" +
            "<p>تبصره: در صورت تأخیر در ارائه حکم قطعی دادگاه افزایش نرخ احتمالی دیه مشمول این بیمه نامه نخواهد بود.</p>\n" +
            "<p><strong><strong>2-5: </strong></strong><strong><strong>غرامت نقص عضو</strong></strong><strong><strong>:</strong></strong>&nbsp;بر اساس درصد تعیین شده در مراجع قانونی ذی صلاح و حداکثر تا سقف تعهدات مندرج در شرایط خصوصی بیمه نامه یا معادل ارزان ترین نوع دیه رایج هر کدام که کمتر باشد.</p>\n" +
            "<p><strong><strong>3-5: </strong></strong><strong><strong>هزینه های پزشکی</strong></strong><strong><strong>: </strong></strong>در صورت وقوع حادثه منجر به جرح استفاده کنندگان از آسانسور چنانچه صدمات وارده مشمول نقص عضو قرار نگیرد هزینه های پزشکی زیاندیده بر اساس اصل اسناد و مدارک معتبر پزشکی و با تائید پزشک معتمد و کارشناس بیمه گر حداکثر تا میزان تعهدات مندرج در شرایط خصوصی بیمه نامه پرداخت می گردد.</p>\n" +
            "<p>1-3-5- در صورتی که هزینه های پزشکی توسط بیمه گذار پرداخت شده باشد چک خسارت در وجه وی و در غیر این صورت در وجه زیاندیده صادر می گردد.</p>\n" +
            "<p>2-3-5- در صورتی که زیاندیده از خدمات سازمان تامین اجتماعی یا سازمان های مشابه استفاده نماید تعهد بیمه گر در جبران هزینه های پزشکی عبارت است از مازاد غرامت پرداخت شده توسط سازمان مذکور تا میزان خسارت قابل پرداخت در این بیمه نامه.</p>\n" +
            "<p><strong><strong>4-5- </strong></strong><strong><strong>خسارت مالی</strong></strong>: خسارت مالی بر اساس نظر کارشناس بیمه گر و یا کارشناس رسمی دادگستری معتمد بیمه گر و مدارک مثبته تعیین خواهد گردید . در غیر اینصورت رای مراجع قضایی ملاک عمل خواهد بود . بدیهی است در هر صورت تعهدات بیمه گر از سقف مندرج در بیمه نامه فراتر نخواهد رفت.</p>\n" +
            "<p><strong><strong>5-5- </strong></strong><strong><strong>هزینه دادرسی و دفاع از بیمه گذار</strong></strong><strong><strong>: </strong></strong>جهت<strong><strong>&nbsp;</strong></strong>تبرئه نمودن محکومیت خود در خصوص موارد تحت پوشش بیمه نامه، مشروط به برائت وی در مراجع قضایی، با موافقت کتبی بیمه گر قبل از شروع دادرسی، در تعهد بیمه گر خواهد بود.</p>\n" +
            "<p><strong><strong>6-5- </strong></strong><strong><strong>دیه یا ارش ناشی از جرح</strong></strong><strong><strong>:</strong></strong>&nbsp;نوعی دیه است که در قانون از قبل تعیین نشده است. بر طبق ماده 367 قانون مجازات اسلامی مصوب 1370هر جنایتی که بر عضو کسی وارد شود و شرعاً مقدار خاصی به عنوان دیه برای آن تعیین نشده باشد کسی که مرتکب جرم شده است باید ارش بپردازد. تعیین ارش معمولا با کارشناسی پزشکی قانونی و رای دادگاه است.</p>\n" +
            "<p><strong><strong>فصل سوم</strong></strong><strong><strong>: </strong></strong><strong><strong>وظایف و تعهدات بیمه گذار </strong></strong></p>\n" +
            "<p><strong><strong>ماده</strong></strong><strong><strong>6- </strong></strong><strong><strong>رعایت اصل حسن نیت</strong></strong><strong><strong>:</strong></strong>&nbsp;بیمه گذار مکلف است با رعایت دقت و صداقت در پاسخ به پرسش های بیمه گر به عمد از اظهار مطلبی خودداری نماید و یا به عمد بر خلاف واقع اظهاری بنماید بیمه نامه باطل خواهد بود ولو مطلبی که کتمان شده یا بر خلاف واقع اظهار شده است هیچ گونه تاثیری در وقوع حادثه نداشته باشد. به علاوه نه فقط وجوه پرداختی بیمه گذار به وی مسترد نخواهد شد بلکه بیمه گر می تواند اقساط حق بیمه را که تا آن تاریخ عقب افتاده است نیز از بیمه گذار مطالبه نماید.</p>\n" +
            "<p><strong><strong>ماده </strong></strong><strong><strong>7 </strong></strong><strong><strong>&ndash;</strong></strong>&nbsp;تشدید خطر: هر گاه در طول مدت بیمه تغییراتی در کیفیت و وضعیت کار موضوع بیمه بوجود آید که موجب تشدید خطر شود و یا تغییری در محدوده مکانی موضوع بیمه بوجود آید ولو آنکه منجر به تشدید خطر نشود بیمه گذار موظف است بلافاصله موضوع را به اطلاع بیمه گر برساند. اگر تشدید خطر یا تغییر وضعیت موضوع بیمه در نتیجه عمل بیمه گذار نباشد مشارالیه باید مراتب را ظرف 10 روز از تاریخ اطلاع خود رسماً به بیمه گر اعلام کند. در صورت تشدید خطر قبل از وقوع خسارت، بیمه گر می تواند حق بیمه اضافی را متناسب با خطر برای مدت باقیمانده مطالبه و در صورت عدم پرداخت آن توسط بیمه گذار بیمه نامه را فسخ نماید. هر گاه بعد از وقوع حادثه معلوم شود که خسارت ناشی از تشدید خطر بوده است بیمه گر می تواند خسارت را به نسبت حق بیمه تعیین شده &nbsp;به حق بیمه متناسب با خطر مشدد، پرداخت نماید.</p>\n" +
            "<p><strong><strong>ماده </strong></strong><strong><strong>8- </strong></strong><strong><strong>پرداخت حق بیمه</strong></strong><strong><strong>: </strong></strong>بیمه نامه با تقاضای بیمه گذار<strong><strong>&nbsp;</strong></strong>و قبول بیمه گر صادر می شود ولی شروع پوشش بیمه ای و اجرای تعهدات بیمه گر منوط به پرداخت حق بیمه به ترتیبی است که در بیمه نامه پیش بینی شده است . چنانچه پرداخت حق بیمه به صورت قسطی باشد و بیمه گذار هر یک از اقساط موعد رسیده را به هر دلیل پرداخت نکند بیمه گر می تواند بیمه نامه را با رعایت ماده 25 این شرایط عمومی فسخ نماید. چنانچه بیمه گر بیمه نامه را فسخ نکرده باشد در صورت وقوع حادثه ، خسارت به نسبت حق بیمه پرداخت شده، به حق بیمه ای که تا زمان وقوع حادثه باید پرداخت می شد پرداخت خواهد شد مگر آنکه در شرایط خصوصی بیمه نامه ضوابط دیگری درج شده باشد.</p>\n" +
            "<p><strong><strong>ماده </strong></strong><strong><strong>9-</strong></strong>&nbsp;بیمه گذار موظف است حسب مورد مقررات شورای عالی حفاظت فنی را رعایت نماید و اقدامات لازم و متعارف را برای جلوگیری از وقوع حوادث و توسعه خسارت به عمل آورد.</p>\n" +
            "<p><strong><strong>ماده </strong></strong><strong><strong>10- </strong></strong><strong><strong>اعلام خسارت</strong></strong>: بیمه گذار موظف است از تاریخ اطلاع خود از وقوع هر گونه حادثه موضوع این بیمه نامه و همچنین دریافت هر نوع ادعا و یا مطالبه اشخاص ثالث علیه خود که به این بیمه نامه مربوط می شود( اعم از کتبی یا شفاهی) اقدامات زیر را انجام دهد:</p>\n" +
            "<p>1.حداکثر ظرف پنج روز کاری به یکی از شعب بیمه گر مراجعه و با تکمیل فرم اعلام خسارت، وقوع حادثه و یا ادعای مطروحه را اعلام نماید و یا مراتب را ظرف مدت مذکور از طریق پست سفارشی به اطلاع بیمه گر برساند.</p>\n" +
            "<ol start=\"2\">\n" +
            "<li>خواسته یا موضوع دعوا، نام و نشانی خواهان و یا اقامه کننده دعوا و عنوانی که به موجب آن مطالبه خسارت و یا اقامه دعوا شده است، مشخصات زیاندیده، نام و نشانی شهود احتمالی، مبلغ مورد ادعا و هر گونه اطلاعات، مشخصات و نکات دیگر مربوط به موضوع را که بر آن &nbsp;وقوف دارد و هر نوع اسناد و مدارکی را که در این باره در اختیار دارد به بیمه گر تسلیم و بیمه گر را در تحقیقات و رسیدگی و دفاع کمک نماید.</li>\n" +
            "<li>برای بازدید از محل حادثه و انجام امور کارشناسی همکاری لازم را با بیمه گر به عمل آورد.</li>\n" +
            "</ol>\n" +
            "<p><strong><strong>ماده </strong></strong><strong><strong>11- </strong></strong><strong><strong>اصل جانشینی</strong></strong><strong><strong>: </strong></strong>بیمه گر قائم مقام بیمه گذار با حق واگذاری به غیر، در دعاوی مربوط به این بیمه نامه محسوب می شود که بتواند پرونده های مربوط را در مراجع قضایی تا میزان تعهد این بیمه نامه تعقیب نماید. بیمه گذار در طول مدت جریان دعوی نباید اقدامی به عمل آورد که به حقوق بیمه گر در تعقیب دعوی لطمه وارد آورد ولی نسبت به مازاد تعهدات این بیمه نامه بیمه گذار حق هر گونهاقدامی خواهد داشت.</p>\n" +
            "<p><strong><strong>ماده </strong></strong><strong><strong>12-</strong></strong>&nbsp;قبول هرگونه مسئولیت و سازش در مورد خسارت های جانی و مالی از طرف بیمه گذار بدون موافقت کتبی بیمه گر تعهدی برای بیمه گر ایجاد نمی کند مگر اینکه عمل او موجب جلوگیری از تشدید خطر و به مصلحت بیمه گر باشد در غیر اینصورت بیمه گر می تواند از پرداخت خسارت خودداری نموده و یا خسارت پرداختی را از بیمه گذار مطالبه نماید.</p>\n" +
            "<p><strong><strong>ماده </strong></strong><strong><strong>13</strong></strong>- چنانچه بیمه گذار به تشخیص مراجع ذیصلاح سهواً وظایف مندرج در این بیمه نامه را انجام ندهد و باعث افزایش تعهد بیمه گر و یا مانع تشخیص علت یا ماهیت حادثه شود بیمه گر می تواند به نسبت تاثیر قصور بیمه گذار از میزان خسارت قابل پرداخت بکاهد، حکم این ماده نافی حقوق زیاندیده نخواهد بود.</p>\n" +
            "<p><strong><strong>ماده </strong></strong><strong><strong>14</strong></strong>- بیمه گذار موظف است رضایت نامه محضری از دریافت کننده مبلغ خسارت به نفع بیمه گر و بیمه گذار و سایر ذینفعان ، پس از اعلام مبلغ خسارت از سوی بیمه گر دریافت نماید. بدیهی است در صورت عدم ارائه رضایت نامه محضری از سوی دریافت کننده مبلغ خسارت، بیمه گذار موظف است اقرارنامه محضری به نفع بیمه گر و سایر ذینفعان خسارت، ارائه نماید. بدیهی است در این صورت بیمه گر وجه خسارت را به حساب دادگستری مربوطه واریز خواهد نمود.</p>\n" +
            "<p><strong><strong>ماده </strong></strong><strong><strong>15-</strong></strong>&nbsp;هر گاه مفاد بیمه نامه و اوراق الحاقی با موفقیت هایی که بین طرفین به عمل آمده است مطابقت نداشته باشد بیمه گذار موظف است ظرف 15 روز از تاریخ دریافت بیمه نامه یا الحاقیه به طور کتبی تقاضای اصلاح نماید و الحاقیه اصلاحی را دریافت نماید و گرنه اوراق مذکور قطعی تلقی خواهد شد.</p>\n" +
            "<p><strong><strong>ماده </strong></strong><strong><strong>16-</strong></strong>&nbsp;در صورتی که بیمه گذار مالک آسانسور باشد موظف است در صورت اعلام خسارت نسبت به ارائه قرارداد معتبر سرویس و نگهداری( آسانسور منعقده با یک شرکت معتبر دارای مجوز)به بیمه گر اقدام نماید. در غیر اینصورت بیمه گر هیچگونه تعهدی در جبران خسارت نخواهد داشت.</p>\n" +
            "<p><strong><strong>ماده </strong></strong><strong><strong>17- </strong></strong>تعبیه زنگ اعلام خطر در آسانسور الزامی است.</p>\n" +
            "<p><strong><strong>ماده </strong></strong><strong><strong>18-</strong></strong>&nbsp;سرویس و نگهداری آسانسور بایستی توسط شرکت هایی که دارای مجوز لازم جهت این کار باشد انجام پذیرد.</p>\n" +
            "<p><strong><strong>فصل چهارم</strong></strong><strong><strong>: </strong></strong><strong><strong>وظایف و تعهدات بیمه گر</strong></strong></p>\n" +
            "<p><strong><strong>ماده </strong></strong><strong><strong>19- </strong></strong>ملاک تشخیص مسئولیت بیمه گذار رای یا نظر مراجع قانونی ذیصلاح است. در مواردی که مسئولیت بیمه گذار با توجه به اسناد و مدارک ارائه شده از نظر بیمه گر محرز باشد، بیمه گر می تواند قبل از صدور رای مراجع قانونی ذیصلاح، در صورت توافق با بیمه گذار و اخذ رضایتنامه از شاکی یا شاکیان، خسارت مربوطه را بر اساس نظر کارشناس و پزشک معتمد خود پرداخت کند. در این صورت بیمه گر در برابر هر گونه ادعای بعدی تعهدی نخواهد داشت.</p>\n" +
            "<p><strong><strong>ماده </strong></strong><strong><strong>20-</strong></strong>&nbsp;در مواردی که پرداخت خسارت به صورت توافقی انجام نشده و موکول به ارائه رای دادگاه شده است، حسب مورد زیاندیده، وارث قانونی یا قائم مقام قانونی آن ها مکلفند ظرف پانزده روز از تاریخ ابلاغ رای قطعی یا ظرف پانزده روز پس از قطعی شدن رای ابلاغی با مدارک لازم برای دریافت خسارت به بیمه گر مراجعه و درخواست خود را تسلیم نمایند. بیمه گر مکلف است به محض وصول درخواست، آن را ثبت و ضمن تحویل رسیدی به متقاضی مشتمل بر نام متقاضی، تاریخ تسلیم و شماره ثبت، نقصان یا کامل بودن مدارک را در حضور متقاضی بررسی کند. چنانچه مدارک در زمان تقاضا کامل باشد بیمه گر موظف است حداکثر ظرف پانزده روز از تاریخ تقاضا خسارت متعلقه را پرداخت نماید و چنانچه مدارک تسلیمی ناقص باشد، مراتب را حضوراً و به صورت کتبی به متقاضی اعلام تا نسبت به رفع نقص حداقل ظرف یک هفته اقدام کند.</p>\n" +
            "<p>تبصره: عدم مراجعه اشخاص مذکور ظرف مهلت مقرر و یا تاخیر در تکمیل مدارک موجب افزایش تعهدات بیمه گر نخواهد بود.</p>\n" +
            "<p><strong><strong>ماده </strong></strong><strong><strong>21- </strong></strong>بیمه گر خسارت موضوع این بیمه نامه را با اطلاع بیمه گذار به زیاندیده یا وارث قانونی وی پرداخت خواهد کرد و به محض پرداخت خسارت، در مقابل بیمه گذار و شخص یا اشخاص زیاندیده بری الذمه می گردد. سایر هزینه های تحت پوشش، حسب مورد به بیمه گذار یا زیاندیده پرداخت خواهد شد. چنانچه پس از تکمیل مدارک لازم، بیمه گر در پرداخت خسارت تاخیر کند افزایش خسارت ناشی از افزایش احتمالی مبلغ دیه بر عهده بیمه گر خواهد بود.</p>\n" +
            "<p><strong><strong>ماده </strong></strong><strong><strong>22-</strong></strong>&nbsp;درصورتی که مسئولیت موضوع این بیمه نامه به موجب بیمه نامه های دیگری تحت پوشش قرار گرفته باشد ، بیمه گر می تواند پس از پرداخت کل خسارت تا سقف تعهدات بیمه نامه، به قائم مقامی بیمه گذار نسبت به بازیافت خسارت از بیمه گران مربوط اقدام نمود.</p>\n" +
            "<p><strong><strong>ماده </strong></strong><strong><strong>23-</strong></strong>&nbsp;در صورت صدور رای قطعی مبنی بر مسئولیت بیمه گذار، بیمه گر مکلف به پرداخت خسارت تا سقف تعهدات بیمه نامه بر اساس مفاد رأی صادره و شرایط بیمه نامه خواهد بود.</p>\n" +
            "<p><strong><strong>فصل پنجم</strong></strong><strong><strong>: </strong></strong><strong><strong>خسارت های خارج از تعهد بیمه گر</strong></strong></p>\n" +
            "<p><strong><strong>ماده </strong></strong><strong><strong>24-</strong></strong>&nbsp;خسارت های زیر تحت پوشش این بیمه نامه نمی باشد:</p>\n" +
            "<p>1.خسارت های مستقیم و یا غیر مستقیم ناشی از تشعشعات رادیو اکتیو و انفجار هسته ای</p>\n" +
            "<ol start=\"2\">\n" +
            "<li>حوادث ناشی از جنگ، اعتصاب، شورش، بلوا، تعطیلی کار، عملیات تروریستی و اقدامات براندازی علیه حکومت و عوامل دیگری از این قبیل</li>\n" +
            "<li>خسارت های ناشی از عمد و تقلب بیمه گذار و کارکنان وی و یا سایر افراد در ایجاد حادثه موضوع بیمه با تشخیص مراجع ذیصلاح یا قضایی.</li>\n" +
            "<li>حوادث ناشی از درگیری و نزاع</li>\n" +
            "<li>محکومیت به جزای نقدی به نفع دولت و مجازات های قابل خرید</li>\n" +
            "<li>خسارت وارده به بیمه گذار</li>\n" +
            "<li>حوادث طبیعی مانند سیل، زلزله، صاعقه و امثالی از این قبیل که بیمه گذار در ایجاد آن دخالتی ندارد</li>\n" +
            "<li>خسارت عدم النفع و یا هر گونه خسارت تبعی و غیر مستقیم</li>\n" +
            "<li>هر گونه خسارت جانی و مالی در خارج از کابین آسانسور</li>\n" +
            "</ol>\n" +
            "<p>-هر گونه خسارت وارده در حین تعمیر و نصب آسانسور</p>\n" +
            "<p>11-هر گونه خسارت ناشی از استفاده بالابر</p>\n" +
            "<p>12-کلیه حوادثی که طبق نظر بیمه گر و یا در صورت لزوم رای مراجع قضایی، بیمه گذار مسئول آن شناخته نمی شود</p>\n" +
            "<p>13-در صورتی که در زمان وقوع حادثه ، سرنشینان آسانسور بیش از ظرفیت مجاز آن باشند، بیمه گر تعهدی در جبران خسارت نخواهد داشت.</p>\n" +
            "<p><strong><strong>فصل ششم</strong></strong><strong><strong>: </strong></strong><strong><strong>فسخ بیمه نامه</strong></strong></p>\n" +
            "<p><strong><strong>ماده </strong></strong><strong><strong>25-</strong></strong>&nbsp;در موارد زیر هر یک از طرفین بیمه نامه می تواند با اخطار کتبی 10 روزه بیمه نامه را فسخ نماید:</p>\n" +
            "<p><strong><strong>1-</strong></strong><strong><strong>موارد فسخ از سوی بیمه گر</strong></strong><strong><strong>:</strong></strong></p>\n" +
            "<p>-عدم پرداخت حق بیمه در سررسیدهای مندرج در اعلامیه های بدهکار صادره</p>\n" +
            "<p>-تشدید خطر و عدم موافقت بیمه گذار به پرداخت حق بیمه اضافی مربوطه</p>\n" +
            "<p>-فوت بیمه گذار و عدم انجام وظیفه بیمه گذار توسط وراث یا منتقل الیه</p>\n" +
            "<p><strong><strong>2-</strong></strong><strong><strong>موارد فسخ از سوی بیمه گذار</strong></strong><strong><strong>:</strong></strong></p>\n" +
            "<p>-در صورتی که خطر، برطرف شده یا کاهش یابد و بیمه گر به تخفیف حق بیمه راضی نشود</p>\n" +
            "<p>-متوقف شدن فعالیت بیمه گر به هر دلیل</p>\n" +
            "<p>-عدم تمایل بیمه گذار به ادامه پوشش</p>\n" +
            "<p><strong><strong>ماده </strong></strong><strong><strong>26- </strong></strong><strong><strong>برگشت حق بیمه</strong></strong><strong><strong>:</strong></strong>&nbsp;در صورت فسخ از طرف بیمه گر ، باید حق بیمه که باقی مانده است به صورت روزشمار محاسبه و به بیمه گذار برگشت داده شود. در صورت فسخ بیمه نامه از طرف بیمه گذار حق بیمه مدت بیمه بر اساس تعرفه کوتاه مدت به شرح ذیل محاسبه و بقیه آن مسترد خواهد شد:</p>\n" +
            "<table>\n" +
            "<tbody>\n" +
            "<tr>\n" +
            "<td width=\"142\">\n" +
            "<p><strong><strong>مدت اعتبار</strong></strong></p>\n" +
            "</td>\n" +
            "<td width=\"254\">\n" +
            "<p><strong><strong>حق بیمه بر مبنای حق بیمه یکساله</strong></strong></p>\n" +
            "</td>\n" +
            "</tr>\n" +
            "<tr>\n" +
            "<td width=\"142\">\n" +
            "<p>تا 5روز</p>\n" +
            "</td>\n" +
            "<td width=\"254\">\n" +
            "<p>5 درصد حق بیمه یالانه</p>\n" +
            "</td>\n" +
            "</tr>\n" +
            "<tr>\n" +
            "<td width=\"142\">\n" +
            "<p>از 6 روز تا 15 روز</p>\n" +
            "</td>\n" +
            "<td width=\"254\">\n" +
            "<p>10درصد حق بیمه یالانه</p>\n" +
            "</td>\n" +
            "</tr>\n" +
            "<tr>\n" +
            "<td width=\"142\">\n" +
            "<p>از 16 روز تا 30روز</p>\n" +
            "</td>\n" +
            "<td width=\"254\">\n" +
            "<p>20درصد حق بیمه یالانه</p>\n" +
            "</td>\n" +
            "</tr>\n" +
            "<tr>\n" +
            "<td width=\"142\">\n" +
            "<p>از 31 روز تا 60 روز</p>\n" +
            "</td>\n" +
            "<td width=\"254\">\n" +
            "<p>30درصد حق بیمه یالانه</p>\n" +
            "</td>\n" +
            "</tr>\n" +
            "<tr>\n" +
            "<td width=\"142\">\n" +
            "<p>از 61 روز تا 90 روز</p>\n" +
            "</td>\n" +
            "<td width=\"254\">\n" +
            "<p>40درصد حق بیمه یالانه</p>\n" +
            "</td>\n" +
            "</tr>\n" +
            "<tr>\n" +
            "<td width=\"142\">\n" +
            "<p>از 91 روز تا 120روز</p>\n" +
            "</td>\n" +
            "<td width=\"254\">\n" +
            "<p>50درصد حق بیمه یالانه</p>\n" +
            "</td>\n" +
            "</tr>\n" +
            "<tr>\n" +
            "<td width=\"142\">\n" +
            "<p>از 121روز تا 150</p>\n" +
            "</td>\n" +
            "<td width=\"254\">\n" +
            "<p>60درصد حق بیمه یالانه</p>\n" +
            "</td>\n" +
            "</tr>\n" +
            "<tr>\n" +
            "<td width=\"142\">\n" +
            "<p>از 151 روز تا 180</p>\n" +
            "</td>\n" +
            "<td width=\"254\">\n" +
            "<p>70درصد حق بیمه یالانه</p>\n" +
            "</td>\n" +
            "</tr>\n" +
            "<tr>\n" +
            "<td width=\"142\">\n" +
            "<p>از 181 روز تا 270</p>\n" +
            "</td>\n" +
            "<td width=\"254\">\n" +
            "<p>85درصد حق بیمه یالانه</p>\n" +
            "</td>\n" +
            "</tr>\n" +
            "<tr>\n" +
            "<td width=\"142\">\n" +
            "<p>از 271روز به بالا</p>\n" +
            "</td>\n" +
            "<td width=\"254\">\n" +
            "<p>100درصد حق بیمه یالانه</p>\n" +
            "</td>\n" +
            "</tr>\n" +
            "</tbody>\n" +
            "</table>\n" +
            "<p>&nbsp;</p>\n" +
            "<p><strong><strong>فصل هفتم</strong></strong><strong><strong>: </strong></strong><strong><strong>سایر مقررات</strong></strong></p>\n" +
            "<p><strong><strong>ماده </strong></strong><strong><strong>27- </strong></strong><strong><strong>نحوه حل و فصل اختلاف</strong></strong><strong><strong>: </strong></strong>هر گونه اختلاف ناشی از تفسیر و یا اجرای این بیمه نامه، در صورتی که از طریق مذاکره حل و فصل نشود به داور مرضی الطرفین ارجاع خواهد شد و رای داور مزبور قطعی و برای طرفین لازم الاتباع است. در صورتی که طرفین در مورد انتخاب داور به توافق نرسند موضوع به هیات داوری ارجاع و ترتیب زیر عمل خواهد شد:</p>\n" +
            "<p>1.هر یک از طرفین یک نفر داور اختصاصی تعیین و به طرف دیگر معرفی می نماید.</p>\n" +
            "<p>2.داوران اختصاصی قبل از بحث درباره موضوع مورد اختلاف به اتفاق ، داور دیگری را به عنوان سرداور انتخاب خواهند نمود.</p>\n" +
            "<p>3.رای هیات داوری با اکثریت آرا، معتبر و برای طرفین لازم الاتباع خواهد بود.</p>\n" +
            "<p>4.در صورتی که هر یک از طرفین تا 30روز بعد از انتخاب و معرفی داور طرف مقابل، داور اختصاصی خود را تعیین نکند و یا داوران اختصاصی تا 30روز در مورد تعیین سرداور به توافق نرسند هر یک از طرفین می توانند حسب مورد از دادگاه ذی صلاح درخواست تعیین داور یا سرداور بنماید.</p>\n" +
            "<p><strong><strong>ماده </strong></strong><strong><strong>28- </strong></strong><strong><strong>نشانی و اقامتگاه بیمه گذار</strong></strong><strong><strong>:</strong></strong>&nbsp;نشانی و اقامتگاه قانونی بیمه گذار همان است که در پیشنهاد بیمه و متن این بیمه نامه درج گردیده است. بیمه گذار موظف است تغییر نشانی و اقامتگاه قانونی خود را به صورت کتبی به اطلاع بیمه گر برساند. در غیر این صورت نشانی و اقامتگاه قبلی بیمه گذار معتبر شناخته می شود.</p>\n" +
            "<p><strong><strong>ماده </strong></strong><strong><strong>29- </strong></strong><strong><strong>قلمرو جغرافیایی</strong></strong><strong><strong>:</strong></strong>&nbsp;پوششهای این قرارداد شامل خسارت هایی است که در محدوده جغرافیایی جمهوری اسلامی ایران واقع شده باشد و تعمیم آن به حوادث خارج از کشور مشروط به توافق طرفین است.</p>\n" +
            "<p><strong><strong>ماده </strong></strong><strong><strong>30- </strong></strong><strong><strong>مرور زمان</strong></strong><strong><strong>: </strong></strong>مرور زمان دعاوی ناشی از بیمه بر اساس ماده 36 قانون بیمه مصوب سال 1316 دو سال است و ابتدای آن از تاریخ وقوع حادثه منشاء دعوی خواهد بود لکن دعاوی که قبل از اجرای این قانون در محاکم طرح شده باشد مشمول این ماده نخواهد بود.</p>\n" +
            "<p><strong><strong>ماده </strong></strong><strong><strong>31- </strong></strong><strong><strong>موارد پیش بینی نشده</strong></strong>: در مواردی که در این بیمه نامه ذکر نشده است حسب مورد بر اساس قانون بیمه، عرف بیمه و سایر قوانین جاری کشور جمهوری اسلامی ایران عمل خواهد شد.</p>"
    },
    "ELEVATOR_DES": {
        1:"<p align=\"justify\">\n" +
            "    بیمه مسئولیت مدنی بیمه گذار که براساس آن بیمه گر متعهد می گردد در ازای\n" +
            "    انجام تعهدات و وظایف بیمه گذار و پرداخت حق بیمه در موعد مقرر خسارت وارد به\n" +
            "    استفاده کنندگان از آسانسور که ناشی از قصور و غفلت بیمه گذار باشد را پس از\n" +
            "    محرز شدن مسئولیت وی و با در نظر گرفتن شرایط و استثنائات مندرج در این بیمه\n" +
            "    نامه و اوراق پیوست جبران نماید.\n" +
            "</p>\n" +
            "<p align=\"justify\">\n" +
            "    <strong>خطرات تحت پوشش </strong>\n" +
            "    <strong></strong>\n" +
            "</p>\n" +
            "<p align=\"justify\">\n" +
            "    سقوط، برق گرفتگی، حبس شدن و سایر حوادثی که ناشی از مسئولیت بیمه گذار بوده و\n" +
            "    در این بیمه نامه استثناء نباشد.\n" +
            "</p>\n" +
            "<p align=\"justify\">\n" +
            "    <strong>استثنائات</strong>\n" +
            "    <strong></strong>\n" +
            "</p>\n" +
            "<p align=\"justify\">\n" +
            "    -خسارت ناشی از استفاده از آسانسور غیراستاندارد\n" +
            "</p>\n" +
            "<p align=\"justify\">\n" +
            "    -خسارت ناشی از استفادهی بیش از ظرفیت آسانسور\n" +
            "</p>\n" +
            "<p align=\"justify\">\n" +
            "    -خسارت وارد به کارکنان شرکت های نصب یا نگهداری\n" +
            "</p>\n" +
            "<p align=\"justify\">\n" +
            "    - هرگونه خسارت ناشی از آسانسور و محل نصب آن در شرایط غیر از بهره برداری\n" +
            "</p>\n" +
            "<p align=\"justify\">\n" +
            "    -خسارت های غیر مستقیم وعدم النفع\n" +
            "</p>\n" +
            "<p align=\"justify\">\n" +
            "    -خسارت مالی\n" +
            "</p>\n" +
            "<p align=\"justify\">\n" +
            "    -ارائه ی تصویر قرارداد سرویس و نگهداری آسانسور با یک شرکت معتبر، در زمان\n" +
            "    خسارت الزامی است، در غیر اینصورت بیمه گر تعهدی در پرداخت خسارت نخواهد داشت.\n" +
            "</p>\n" +
            "<p align=\"justify\">\n" +
            "    - تعهدات بیمه‌گر برای هر آسانسور حداکثر به میزان ظرفیت استاندارد آسانسور\n" +
            "    می‌باشد.\n" +
            "</p>\n" +
            "<p align=\"justify\">\n" +
            "    -در صورت حمل بیش از ظرفیت آسانسور بیمه گر تعهدی در قبال پرداخت خسارت نخواهد\n" +
            "    داشت.\n" +
            "</p>\n" +
            "<p align=\"justify\">\n" +
            "    -پرداخت خسارت منوط به انجام بازدیدهای دوره ای و صدور گواهی بازدید توسط\n" +
            "    اشخاص ذیصلاح میباشد.\n" +
            "</p>\n" +
            "<p align=\"justify\">\n" +
            "    - در صورتی که ساختمان جدیدالتاسیس باشد، ارائه ی گواهی استاندارد آسانسور\n" +
            "    الزامیست.\n" +
            "</p>\n" +
            "<p align=\"justify\">\n" +
            "    - در صورتی که عمر ساختمان کمتر از 10 سال باشد، ارائه ی گواهی استاندارد\n" +
            "    اولیه الزامیست و صدور بیمه نامه به شرط قرارداد با شرکت سرویس کار و\n" +
            "    نگهدارنده ی معتبر آسانسور بلامانع می باشد.\n" +
            "</p>\n" +
            "<p align=\"justify\">\n" +
            "    - در صورتی که عمر ساختمان بیشتر از 10 سال می باشد، به دلیل ریسک ناشی از\n" +
            "    استهلاک، وجود گواهی استاندارد الزامیست.\n" +
            "</p>",
        2:"<p>\n" +
            "    به سایت مراجعه کنین و وارد قسمت آسانسور بشین\n" +
            "</p>\n" +
            "<p>\n" +
            "    کافیه فقط تعداد واحدها رو انتخاب کنید. ما بهترین طرح پیشنهادی رو بهتون\n" +
            "    معرفی می کنیم\n" +
            "</p>\n" +
            "<p>\n" +
            "    پوشش های تکمیلی دلخواهتون رو انتخاب کنید.\n" +
            "</p>\n" +
            "<p>\n" +
            "    حتما شرایط خصوصی رو مطالعه کنین تا بدونین چه پوششهای اضافی دارین که خودش به\n" +
            "    تنهایی یک بیمه نامه ست\n" +
            "</p>\n" +
            "<p>\n" +
            "    حق بیمه محاسبه شده رو تو این مرحله میتونید ببینید.\n" +
            "</p>\n" +
            "<p>\n" +
            "    بعد از بررسی دقیق اطلاعات، حق بیمه رو پرداخت کنین .کار شما تموم شد.\n" +
            "</p>\n" +
            "<p>\n" +
            "    بیمه نامه در کمترین زمان ممکن صادر میشه به دستتون میرسه.\n" +
            "</p>",
        3:"<p align=\"justify\">\n" +
            "    بیمه گذار موظف است از تاریخ اطلاع خود از وقوع هر گونه حادثه موضوع این بیمه\n" +
            "    نامه و همچنین دریافت هر نوع ادعا و یا مطالبه اشخاص ثالث علیه خود که به این\n" +
            "    بیمه نامه مربوط می شود( اعم از کتبی یا شفاهی) اقدامات زیر را انجام دهد:\n" +
            "</p>\n" +
            "<p align=\"justify\">\n" +
            "    1- حداکثر ظرف پنج روز کاری به یکی از شعب بیمه گر مراجعه و با تکمیل فرم\n" +
            "    اعلام خسارت، وقوع حادثه و یا ادعای مطروحه را اعلام نماید و یا مراتب را ظرف\n" +
            "    مدت مذکور از طریق پست سفارشی به اطلاع بیمه گر برساند.\n" +
            "</p>\n" +
            "<p align=\"justify\">\n" +
            "    2- خواسته یا موضوع دعوا، نام و نشانی خواهان و یا اقامه کننده دعوا و عنوانی\n" +
            "    که به موجب آن مطالبه خسارت و یا اقامه دعوا شده است، مشخصات زیاندیده، نام و\n" +
            "    نشانی شهود احتمالی، مبلغ مورد ادعا و هر گونه اطلاعات، مشخصات و نکات دیگر\n" +
            "    مربوط به موضوع را که بر آن وقوف دارد و هر نوع اسناد و مدارکی را که در این\n" +
            "    باره در اختیار دارد به بیمه گر تسلیم و بیمه گر را در تحقیقات و رسیدگی و\n" +
            "    دفاع کمک نماید.\n" +
            "</p>\n" +
            "<p align=\"justify\">\n" +
            "    3- برای بازدید از محل حادثه و انجام امور کارشناسی همکاری لازم را با بیمه گر\n" +
            "    به عمل آورد.\n" +
            "</p>\n" +
            "<p align=\"justify\">\n" +
            "    4- پرداخت خسارت حداکثر تا سقف تعهدات در طول مدت بیمه نامه بوده و در هر صورت\n" +
            "    حداکثر تعهد بیمه گر از سرمایه ی مندرج در بیمه نامه فراتر نخواهد بود.\n" +
            "</p>"
    }
};

export {CONST};





































































